import { CommonDependency } from '@/dependency';
import { useQuery } from 'react-query';

export type ChainDetail = {
  id: string;
  name: string;
};

export const useChainList = () => {
  return useQuery<{ chains: ChainDetail[] }>(['chain-list'], async () =>
    CommonDependency.api.getChainList(),
  );
};
